import React from "react";
import { ChevronRight, MessagesSquare } from "lucide-react";
import { BottomSheet, tabBadge } from "./index";

export const inboxOrder = (unreadMessages) => (unreadMessages > 0 ? ["messages", "introductions"] : ["introductions", "messages"]);

const MessagesRow = ({ unread, onOpen }) => (
  <button type="button" className="inbox-sheet__messages" onClick={onOpen}>
    <span className="inbox-sheet__messages-icon">
      <MessagesSquare size={20} strokeWidth={1.75} aria-hidden="true" />
    </span>
    <span className="inbox-sheet__messages-text">
      <span className="inbox-sheet__messages-title">Messages</span>
      <span className="inbox-sheet__messages-note">{unread > 0 ? `${tabBadge(unread)} unread` : "Your conversations"}</span>
    </span>
    {unread > 0 ? <span className="inbox-sheet__dot" aria-hidden="true" /> : null}
    <ChevronRight size={18} strokeWidth={1.75} aria-hidden="true" className="inbox-sheet__chevron" />
  </button>
);

const InboxSheet = ({ unreadMessages = 0, showMessages = true, onOpenMessages, introductions, onClose }) => {
  const order = showMessages ? inboxOrder(unreadMessages) : ["introductions"];
  return (
    <BottomSheet title="Inbox" onClose={onClose} className="inbox-sheet">
      {order.map((part) =>
        part === "messages" ? (
          <MessagesRow
            key="messages"
            unread={unreadMessages}
            onOpen={() => {
              onClose();
              onOpenMessages();
            }}
          />
        ) : (
          <div key="introductions" className="inbox-sheet__introductions">
            {introductions}
          </div>
        ),
      )}
    </BottomSheet>
  );
};

export default InboxSheet;
